/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AllergenRecipeDeleteModalMutationVariables = {|
  id: string
|};
export type AllergenRecipeDeleteModalMutationResponse = {|
  +recipeDeleteAllergen: ?{|
    +deleted: ?boolean
  |}
|};
export type AllergenRecipeDeleteModalMutation = {|
  variables: AllergenRecipeDeleteModalMutationVariables,
  response: AllergenRecipeDeleteModalMutationResponse,
|};
*/


/*
mutation AllergenRecipeDeleteModalMutation(
  $id: ID!
) {
  recipeDeleteAllergen(input: {id: $id}) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeDeleteAllergenPayload",
    "kind": "LinkedField",
    "name": "recipeDeleteAllergen",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AllergenRecipeDeleteModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AllergenRecipeDeleteModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AllergenRecipeDeleteModalMutation",
    "operationKind": "mutation",
    "text": "mutation AllergenRecipeDeleteModalMutation(\n  $id: ID!\n) {\n  recipeDeleteAllergen(input: {id: $id}) {\n    deleted\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e9a5391b834416eef08a7d5f1048c366';

module.exports = node;
